<div class="row">
	<div class="col-12">
		<div class="content-header">Class By Student Form</div>
	</div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
	<div class="row">
		<div class="col-12">
			<div class="card">

				<div class="card-content">
					<div class="card-body">
						<div class="row">
							<div class="col-md">
								<form [formGroup]="classByStudentForm">
									<fieldset class="form-group">
										<label>Title<span class="required_field">*</span></label>
										<input type="text" class="form-control" formControlName="title" name="title"
											id="title" placeholder="Enter Title" [(ngModel)]="class_model.title"
											required>
									</fieldset>
									<fieldset class="form-group">
										<label>Instructor<span class="required_field">*</span></label>
										<ng-select [items]="instructor_list" bindLabel="name" bindValue="_id"
											placeholder="Select Instructor" [(ngModel)]="class_model.instructor"
											[ngModelOptions]="{ standalone: true }" [closeOnSelect]="true"
											(change)="getInstructorId($event)">
										</ng-select>
									</fieldset>
									<fieldset class="form-group" [hidden]="class_status === 'pattern'">
										<label>Status<span class="required_field">*</span></label>
										<ng-select [items]="status_list" bindLabel="name" bindValue="id"
											placeholder="Select Status" [(ngModel)]="class_model.status"
											[ngModelOptions]="{ standalone: true }" [closeOnSelect]="true"
											(change)="getStatusId($event)">
										</ng-select>
									</fieldset>
									<fieldset class="form-group">
										<label>Reference<span class="required_field">*</span></label>
										<ng-select [items]="referenceList" bindLabel="name" [multiple]="true"
											[closeOnSelect]="false" bindValue="_id" placeholder="Select References"
											[(ngModel)]="selectedRef" [ngModelOptions]="{ standalone: true }"
											(change)="getRefId($event)">
											<ng-template ng-header-tmp>
												<div class="btn btn-link" (click)="openModal(myModal)">
													Add New Reference
												</div>
											</ng-template>
										</ng-select>
									</fieldset>
									<fieldset class="form-group">
										<label>Project Tag<span class="required_field">*</span></label>
										<ng-select [items]="project_tags_list" bindLabel="name" bindValue="_id"
											placeholder="Select Project Tag" [(ngModel)]="selected_channel"
											[ngModelOptions]="{standalone: true}" [closeOnSelect]="true"
											(change)="getChangeChannelId($event)">
										</ng-select>
									</fieldset>
									<!-- Zoom Link Field - Only for LIVE -->
									<fieldset class="form-group" *ngIf="isLiveSelected()">
										<label>Zoom Link<span class="required_field">*</span></label>
										<input type="url" class="form-control" [(ngModel)]="class_model.zoom_link"
											[ngModelOptions]="{ standalone: true }" placeholder="https://zoom.us/j/..."
											name="zoom_link">
										<small class="form-text text-muted">Enter the Zoom meeting link for LIVE
											classes</small>
									</fieldset>
									<fieldset class="form-group">
										<label>Admin Notes</label>
										<textarea formControlName="admin_notes" name="admin_notes" id="admin_notes"
											cols="30" rows="3" class="form-control" placeholder="Enter admin notes"
											[(ngModel)]="class_model.admin_notes"></textarea>
									</fieldset>
								</form>
							</div>
							<div class="col-md">

								<form [formGroup]="classByStudentForm">

									<!-- <fieldset class="form-group" [hidden]="class_status !== 'pattern'">
                                      <label>Select Dates <span class="required_field">*</span></label> -->
									<!-- single date input + Add button -->
									<!-- <div class="d-flex align-items-center mb-2">
                                        <input
                                          type="date"
                                          class="form-control me-2"
                                          [(ngModel)]="singleDate"
                                          [ngModelOptions]="{ standalone: true }"
                                        />
                                        <button type="button" class="btn btn-primary" (click)="addDate()">Add</button>
                                      </div> -->
									<!-- list of chosen dates -->
									<!-- <div *ngIf="dateList.length">
                                        <label>Chosen dates:</label>
                                        <ul class="list-group">
                                          <li
                                            class="list-group-item d-flex justify-content-between align-items-center"
                                            *ngFor="let d of dateList; let i = index">
                                            {{ d }}
                                            <button type="button"
                                                    class="btn btn-sm btn-danger"
                                                    (click)="removeDate(i)">
                                              ✕
                                            </button>
                                          </li>
                                        </ul>
                                      </div>
                                    </fieldset> -->
									<fieldset class="form-group" *ngIf="class_status === 'pattern'">
										<label>Schedule<span class="required_field">*</span></label>

										<div class="d-flex justify-content-between">
											<ng-container *ngFor="let d of days">
												<div (click)="toggleDay(d.key)" class="day-circle"
													[class.day-selected]="patternSchedule.get(d.key)?.value">
													{{ d.label }}
												</div>
											</ng-container>
										</div>
									</fieldset>
									<fieldset class="form-group" [hidden]="class_status === 'pattern'">
										<label>Date<span class="required_field">*</span></label>
										<input type="date" class="form-control" formControlName="date"
											[(ngModel)]="class_model.date"
											[ngModel]="class_model.date | date:'yyyy-MM-dd'">
									</fieldset>
									<fieldset class="form-group">
										<label>Start Time<span class="required_field">*</span></label>
										<input type="time" placeholder="Enter start time" class="form-control"
											formControlName="start_time" [(ngModel)]="class_model.start_time">
									</fieldset>
									<fieldset class="form-group">
										<label>End Time<span class="required_field">*</span></label>
										<input type="time" placeholder="Enter end time" class="form-control"
											formControlName="end_time" [(ngModel)]="class_model.end_time">
									</fieldset>
									<fieldset class="form-group">
										<label>Notes</label>
										<textarea formControlName="notes" name="notes" id="notes" cols="30" rows="3"
											class="form-control" placeholder="Enter notes"
											[(ngModel)]="class_model.notes"></textarea>
									</fieldset>

								</form>
							</div>
							<div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">

								<div>
									<button *ngIf="!class_id"
										[disabled]="!classByStudentForm.valid || !class_model.instructor || !class_model.status  "
										[hidden]="class_status === 'pattern'" class="btn btn-primary mx-1"
										(click)="addStudentPopup(studentModal)">+ Student</button>
									<!-- <button *ngIf="!class_id" aria-label="Add Student" [disabled]="!classByStudentForm.valid || !class_model.instructor || !class_model.status" class="btn btn-primary mx-1" (click)="addStudentPopup(studentModal)"> + Student</button> -->
								</div>
								<!-- <button *ngIf="isStudentSubmit || class_id || class_status === 'pattern'" class="btn btn-primary mx-1" (click)="submit()"> -->
								<!-- <button   class="btn btn-primary mx-1" (click)="submit()"> -->
								<!-- Submit -->
								<!-- </button> -->
								<button *ngIf="isStudentSubmit || class_id || class_status === 'pattern'"
									class="btn btn-primary mx-1" (click)="handleSubmit()"> Submit </button>
								<button type="reset" class="btn btn-secondary mx-1" (click)="back()">
									Cancel
								</button>
							</div>
							<div class="col-12 my-2">
								<table class="table mb-0" [hidden]="class_status === 'pattern'">
									<thead>
										<tr>
											<th>Student</th>
											<th>Topics</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody *ngIf="!class_id">
										<tr *ngFor="let student of students_array;let studentIndx=index">

											<td>
												<span>{{ student.student_id}}</span>
											</td>
											<td>
												<span *ngFor="let topic of  student.topic_id;">
													{{topic}} <span *ngIf="student.topic_id.length>1">,</span>
												</span>
											</td>

											<td>
												<i class="ft-trash text-primary cursor-pointer mr-2"
													(click)="deleteStudent(studentIndx)"></i>
											</td>
										</tr>
									</tbody>
									<tbody *ngIf="class_id && class_model.students?.length">
										<tr *ngFor="let student of class_model.students; let studentIndex = index">

											<td>
												<span>{{ student?.student_info?.name || '-' }}</span>
											</td>
											<td>
												<span *ngIf="student?.topic_info?.length; else noTopics">
													<span *ngFor="let topic of student.topic_info; let last = last">
														{{ topic?.name || '-' }}<span *ngIf="!last">, </span>
													</span>
												</span>
												<ng-template #noTopics>-</ng-template>
											</td>

											<td>
												<i class="ft-edit text-primary cursor-pointer mr-2"
													(click)="editStudentPopup(studentModal,student)"
													*ngIf="student"></i>
												<i class="ft-trash text-danger cursor-pointer mr-2"
													(click)="deleteStudentFromClass(student?.student_info?._id, studentIndex)"
													*ngIf="student"></i>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-------------- Add Reference Popup ------------------------------------------->
<div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Add Reference</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form [formGroup]="referenceForm">
				<div class="form-group">
					<label>Name</label>
					<input type="text" class="form-control" formControlName="name" [(ngModel)]="reference_model.name">
				</div>
				<div class="form-group">
					<label>Link</label>
					<input type="text" class="form-control" formControlName="links" [(ngModel)]="reference_model.links">
				</div>
				<div class="form-group">
					<label>Description</label>
					<textarea class="form-control" formControlName="description"
						[(ngModel)]="reference_model.description" name="notes" id="notes" cols="30" rows="2"></textarea>
				</div>
				<div class="form-group">
					<label>Notes</label>
					<textarea class="form-control" formControlName="notes" [(ngModel)]="reference_model.notes"
						name="notes" id="notes" cols="30" rows="2"></textarea>
				</div>
				<div class="form-group">
					<label>Admin Notes</label>
					<textarea class="form-control" formControlName="admin_notes"
						[(ngModel)]="reference_model.admin_notes" name="notes" id="notes" cols="30" rows="2"></textarea>
				</div>
			</form>

		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="submitRef()">Submit</button>
		</div>
	</ng-template>
</div>
<!-------------- Edit Reference Popup ------------------------------------------->
<div>
	<ng-template #myModal2 let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Update Reference</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form [formGroup]="referenceForm">
				<div class="form-group">
					<label>Name</label>
					<input type="text" class="form-control" [(ngModel)]="reference_model.name"
						[ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Link</label>
					<input type="text" class="form-control" [(ngModel)]="reference_model.links"
						[ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Description</label>
					<textarea class="form-control" [(ngModel)]="reference_model.description"
						[ngModelOptions]="{standalone: true}" name="notes" id="notes" cols="30" rows="2"></textarea>
				</div>
				<div class="form-group">
					<label>Notes</label>
					<textarea class="form-control" [(ngModel)]="reference_model.notes"
						[ngModelOptions]="{standalone: true}" name="notes" id="notes" cols="30" rows="2"></textarea>
				</div>
				<div class="form-group">
					<label>Admin Notes</label>
					<textarea class="form-control" [(ngModel)]="reference_model.admin_notes"
						[ngModelOptions]="{standalone: true}" name="notes" id="notes" cols="30" rows="2"></textarea>
				</div>
			</form>

		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="updateRef()">Update</button>
		</div>
	</ng-template>
</div>

<!---------- Popup ---------------->
<div>
	<ng-template #studentModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title" *ngIf="!class_id">Add Student</h4>
			<h4 class="modal-title" *ngIf="class_id">Update Student</h4>

			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<fieldset class="form-group my-1">
				<label>Student<span class="required_field">*</span></label>
				<ng-select [items]="student_list" bindLabel="name" bindValue="id" placeholder="Select Student"
					[(ngModel)]="select_student" [ngModelOptions]="{ standalone: true }" [closeOnSelect]="true"
					(change)="getStudentId($event)" [disabled]="isClassIdSet()" [appendTo]="'body'"
					[virtualScroll]="true">
				</ng-select>
			</fieldset>
			<fieldset class="form-group my-1">
				<label>Enrollment<span class="required_field">*</span></label>
				<ng-select [items]="enrollment_list" bindLabel="name" bindValue="_id" placeholder="Select Student"
					[(ngModel)]="select_enrollment" [ngModelOptions]="{ standalone: true }" [closeOnSelect]="true"
					(change)="getEnrollmentId($event)" [disabled]="isClassIdSet()" [appendTo]="'body'"
					[virtualScroll]="true">
				</ng-select>
			</fieldset>
			<fieldset class="form-group my-1">
				<label>Course<span class="required_field">*</span></label>
				<ng-select [items]="course_list" bindLabel="title" bindValue="_id" placeholder="Select course"
					[(ngModel)]="select_course" [ngModelOptions]="{ standalone: true }" [closeOnSelect]="false"
					(change)="getCourseId($event)" [disabled]="isClassIdSet()" [appendTo]="'body'"
					[virtualScroll]="true">
				</ng-select>
			</fieldset>
			<fieldset class="my-1">
				<input type="radio" name="radio" value="Session Wise" (change)="getRadioValue($event)"> Session Wise
				<input type="radio" name="radio" value="Topic Wise" (change)="getRadioValue($event)"> Topic Wise

			</fieldset>
			<fieldset class="form-group my-1" *ngIf="radio_button == 'Session Wise'">
				<label>Session</label>
				<ng-select [items]="session_list" bindLabel="title" placeholder="Select Session"
					[(ngModel)]="select_session" [ngModelOptions]="{ standalone: true }" [closeOnSelect]="true"
					(change)="getSessionId($event)">
				</ng-select>
			</fieldset>
			<fieldset class="form-group my-1" *ngIf="radio_button == 'Topic Wise'">
				<label>Topics<span class="required_field">*</span></label>
				<ng-select [items]="topic_list" bindLabel="topic_name" bindValue="topic_id" placeholder="Select topic"
					[(ngModel)]="select_topic" [multiple]="true" [ngModelOptions]="{ standalone: true }"
					[closeOnSelect]="false" (change)="getTopicId($event)">
				</ng-select>
			</fieldset>
		</div>

		<div class="modal-footer">
			<button *ngIf="!class_id" class="btn btn-primary" (click)="addStudent();modal.dismiss()">Submit</button>
			<button *ngIf="class_id" class="btn btn-primary" (click)="updateStudent();modal.dismiss()">Update</button>
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		</div>
	</ng-template>
</div>
<ngx-spinner></ngx-spinner>